import React from "react";
import { Box, Breadcrumbs, Button, Typography } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Label from '../Label/Label';

const BreadcrumbHeader = ({text,onBackClick , first , second , third}) => {
  return (
    <Box display="flex" alignItems="center" gap={2} pl={2}>
      {/* Back Button */}
      <Button
        startIcon={<ArrowBackIcon />}
        sx={{
          textTransform: "none",
          borderRadius: "20px !important",
          paddingX: 2,
          paddingY: 0.2,
          backgroundColor: "#E9EAEB",
          color: "Black",
        }}
        onClick={onBackClick}
      >
        Back
      </Button>

      {/* Breadcrumbs */}
      <Breadcrumbs
        aria-label="breadcrumb"
        separator="›"
        sx={{ fontSize: "14px" }}
      >
        {first && <Label color="text.secondary" text={ first }></Label>}
        {second && <Label color="text.secondary" text={second}></Label>}
        {third && (
          <Typography color="primary" fontSize={12} fontWeight={700}>
            {third}
          </Typography>
        )}
      </Breadcrumbs>
    </Box>
  );
};

export default BreadcrumbHeader;
